import { from } from "rxjs";


export * from "./otp/otp.widget";
export * from "./pharmacy-product/pharmacy-product.widget";
export * from "./barcode-scanner/barcode-scanner.widget";
export * from "./common-data/common-data.widget";
export * from "./documents/documents.widget";
export * from "./aside-appointments/aside-appointments.widget";
export * from "./file-dropper/file-dropper.widget";
export * from "./banner-setting/banner-setting.widget";
export * from "./new-lab-invoice/new-lab-invoice.widget";
export * from "./new-lab-parameter/new-lab-parameter.widget";
export * from "./new-lab-report/new-lab-report.widget";
export * from "./new-lab-timeline/new-lab-timeline.widget";
export * from "./timeline/timeline.widget";
export * from "./pharmacy-indent/pharmacy-indent.widget"
export * from "./aside-appointments/aside-appointments.widget"
export * from "./appointment-invoice/appointment-invoice.widget";
export * from "./pharmacy-header/pharmacy-header.widget";
export * from "./chat-box/chat-box.widget";
export * from "./color-identification/color-identification.widget";
export * from "./img-crop/img-crop.widget";
export * from "./img-capture/img-capture.widget";
export * from "./color-identification/color-identification.widget";
export * from "./img-crop/img-crop.widget";
export * from "./Ob-header/ob-header";
export * from "./signature/signature.widget";
export * from "./diet-header/diet-header.widget";
export * from "./gyn-header/gyn-header.widget";
export * from "./pediatric-header/pediatrics-header.page";
export * from "./receipt-view/receipt-view.widget";
export * from "./parameter-input/parameter-input.widget";
export * from "./genetic-speciality-encounter-header/genetic-header";
export * from "./physiotherapy-encounter-header/physiotherapy-header";
export * from "./emergency-header/emergency-header.widget";
export * from "./lab-status-identification/lab-status-identification.widget";
//export * from "./img-draw/img-draw.widget";
export * from "./nurse-header/nurse-header.page";
export * from "./test-chat-box/test-chat-box.widget";
export * from "./telemedicine/telemedicine.widget";
export * from "./messaging/messaging.widget";
export * from "./ivf-header/ivf-header.widget";

export * from "./pharmacy-invoice/pharmacy-invoice.widget";
export * from "./patient-registration-invoice/patient-registration-invoice.widget";
export * from "./sacn-invoice/scan-invoice-widget";
export * from "./service-and-payment-invoice/service-and-payment-invoice.widget";

export * from "./pharmacy-invoice-without-gst/pharmacy-invoice-without-gst.widget";